import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { Input, Box, Icon } from '@elparking/components'

import { debounce } from 'commons/js/util/functions'

import messages from './messages'

const BoxShadow = styled.div`
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);
`

const SEARCH_DELAY = 250

function Search ({ onChange }) {
    const intl = useIntl()
    const [search, setSearch] = useState('')

    const onChangeDebounced = useCallback(
        debounce(onChange, SEARCH_DELAY),
        [onChange]
    )

    const handleChange = (value) => {
        setSearch(value)
        onChangeDebounced(value)
    }

    return (
        <BoxShadow>
            <Input
              leftIcon={<Box ml='16px'><Icon type='len' size='large' color='gray' /></Box>}
              height='64px'
              placeholder={intl.formatMessage(messages.placeholder)}
              onChange={handleChange}
              value={search}
            />
        </BoxShadow>
    )
}

Search.propTypes = {
    onChange: PropTypes.func,
}

export default Search
